// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useCallback, useState } from 'react';
import { Box } from '@mui/material';
import FormDialog from '../../../components/Dialog/FormDialog';
import TextInput from '../../../components/Form/TextInput';
import useCreateOperatorConfiguration from '../../../hooks/mutations/registry/configuration/useCreateOperatorConfiguration';
import useMutate from '../../../hooks/mutations/useMutate';
import { SUC_CRE_OP_CONF, ERR_CRE_OP_CONF } from '../../../utils/strings';

type DialogProps = {
  open: boolean;
  onClose: () => void;
};

export const CreateOperatorConfigurationDialog = ({ open, onClose }: DialogProps) => {
  const [upgrader, setUpgrader] = useState<string>('');
  const mutate = useMutate();
  const createOperatorConfiguration = useCreateOperatorConfiguration();

  const resetState = useCallback(() => {
    setUpgrader('');
  }, []);

  const handleClose = useCallback(() => {
    resetState();
    onClose();
  }, [resetState, onClose]);

  const handleSubmit = useCallback(async () => {
    await mutate(createOperatorConfiguration, { upgrader }, SUC_CRE_OP_CONF, ERR_CRE_OP_CONF);
    handleClose();
  }, [createOperatorConfiguration, handleClose, mutate, upgrader]);

  const disableSubmit = !upgrader;

  return (
    <FormDialog
      open={open}
      title="Create Operator Configuration"
      onCancel={handleClose}
      onSubmit={handleSubmit}
      submitName="Create"
      isSubmitDisabled={disableSubmit}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
        <TextInput
          enableTopLabel
          label="Upgrader Party ID"
          value={upgrader}
          setValue={setUpgrader}
        />
      </Box>
    </FormDialog>
  );
};
